module.exports = __webpack_public_path__ + "img/online_bg_wap_2023_01_19_2.db5d770f.png";